<template>
  <AccountFrame>
    <SuccessFrame
      title="ยินดีด้วย"
      btn-text="เข้าสู่ระบบ"
      :on-click="handleClick"
    >
      <p>
        ชื่อผู้ใช้ของท่านได้รับการยืนยันแล้ว
        ตอนนี้ท่านสามารถเข้าใช้งานระบบได้แล้ว
      </p>
      <div class="flex grow place-content-center">
        <CheckCircleIcon class="w-36 text-green" />
      </div>
    </SuccessFrame>
  </AccountFrame>
</template>

<script setup lang="ts">
import AccountFrame from "@/components/account/AccountFrame.vue";
import SuccessFrame from "@/components/account/SuccessFrame.vue";
import { ROUTE_NAMES } from "@/router/constants";
import { CheckCircleIcon } from "@heroicons/vue/24/outline";
import { ref, watchEffect } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const timeout = ref();

function changePage() {
  router.push({ name: ROUTE_NAMES.LOGIN });
}

function setTimeOutClose() {
  timeout.value = setTimeout(changePage, 5000);
}

function handleClick() {
  clearTimeout(timeout.value);
  changePage();
}

watchEffect(async () => {
  setTimeOutClose();
});
</script>
